import { getWholeSlugMap } from './http/dictionary';
import type { QueryObserverOptions } from '@tanstack/query-core';
import type { SlugMapDict } from 'src/lib/dictionary/dictionary';

// Constants
export const SLUG_MAP = 'slug-map';
export const WHOLE = 'whole';

export const getWholeSlugMapQuery = (): QueryObserverOptions<SlugMapDict> => ({
    queryKey: [SLUG_MAP, WHOLE],
    queryFn: () => getWholeSlugMap(),
});
